import { useAuth, useUser } from '@clerk/clerk-react';
import { useUserProfile } from './useUserProfile';
import { UserRole } from '@/lib/types';

/**
 * Hook for admin authentication that builds on existing useUserProfile
 * Leverages the existing user profile system for role checking
 */
export function useAdminAuth() {
  const { isSignedIn, isLoaded: authLoaded } = useAuth();
  const { user, isLoaded: userLoaded } = useUser();
  const { profile, loading: profileLoading, error } = useUserProfile();

  // Consider both Clerk loading states and profile loading
  const loading = !authLoaded || !userLoaded || profileLoading;
  const isAuthenticated = authLoaded && userLoaded && isSignedIn && !!user;
  const userRole = profile?.role || null;
  

  
  // Role checking functions
  const isAdmin = userRole === 'admin';
  const isModerator = userRole === 'moderator' || userRole === 'admin';
  const isUser = userRole === 'user' || !userRole; // Default to user if no role set
  
  // Check if user has a specific role
  const hasRole = (role: UserRole): boolean => {
    return userRole === role;
  };

  // Check if user has admin access (admin or moderator)
  const hasAdminAccess = isAdmin || isModerator;

  return {
    // User info
    user,
    userProfile: profile,
    userRole,
    isAuthenticated,
    
    // Role checks
    isAdmin,
    isModerator, 
    isUser,
    hasRole,
    hasAdminAccess,
    
    // Loading states
    loading,
    error,
  };
} 